module.exports = __webpack_public_path__ + "img/nastyamerkulova.5af6d978.jpg";